import { storage } from "config/firebase";
import firebase from "firebase";
import { toast } from "react-toastify";

export const fetchBlogs = () => async (dispatch) => {
  await firebase
    .firestore()
    .collection("tech_Forum")
    .where("type", "==", "admin")
    .onSnapshot((query) => {
      let newArr = [];
      query.forEach((doc) => {
        newArr.push({ id: doc.id, ...doc.data() });
      });
      dispatch({ type: "GET_ADMIN_BLOGS", payload: newArr });
    });
};

export const getEductions =
  (onComplete = () => {}) =>
  async (dispatch) => {
    await firebase
      .firestore()
      .collection("admin-education")
      .get()
      .then(async (query) => {
        let temp_data = [];
        query.forEach((doc) => {
          temp_data.push({ id: doc.id, ...doc.data() });
        });
        dispatch({ type: "EDUCTION_VIDEOS", payload: temp_data });
        onComplete();
      });
  };

export const AddBlogData =
  (blogData, onComplete = () => {}) =>
  async (dispatch) => {
    const { image, editingBlogId, oldImage, athleteId, ...athleteBlogData } =
      blogData;
    const created_at = firebase.firestore.Timestamp.now();
    const athleteBlog = { ...athleteBlogData, created_at };
    const storageRef = storage.ref();
    const imageRef = storageRef.child(`athleteBlogImages/${image.name}`);

    imageRef
      .put(image)
      .then((snapshot) => {
        return snapshot.ref.getDownloadURL();
      })
      .then((url) => {
        const newData = {
          ...athleteBlog,
          imageUrl: url,
        };

        return firebase
          .firestore()
          .collection("tech_Forum")
          .add(newData)
          .then((doc) => {
            dispatch({
              type: "ADD_BLOG_DATA",
              payload: { id: doc.id, ...newData },
            });

            const notificationData = {
              createdAt: firebase.firestore.Timestamp.now(),
              athleteId: blogData.athlete_uid,
              isRead: [],
              type: "blog",
            };

            return firebase
              .firestore()
              .collection("fan_notifications")
              .add(notificationData)
              .then(() => {
                toast.success("Blog Successfully Added");
                onComplete();
              });
          });
      })
      .catch((error) => {
        console.error("Error adding blog or notification:", error);
        toast.error("Something went wrong while adding the blog.");
      });
  };

export const getBlogData =
  (uid, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let moreData = firebase
      .firestore()
      .collection("tech_Forum")
      .where("athlete_uid", "==", uid)
      .orderBy("created_at");
    if (lastDocument !== "") {
      moreData = moreData.startAfter(lastDocument);
    }
    moreData
      .limit(5)
      .get()
      .then(async (query) => {
        let newArr = [];
        // query.forEach((doc) => {
        // });

        for await (let doc of query.docs) {
          newArr.push({ id: doc.id, ...doc.data() });
        }
        dispatch({
          type: lastDocument != "" ? "MOREBLOGDETAILS" : "BLOGDETAILS",
          payload: {
            data: newArr,
            lastDocument: query.docs[newArr.length - 1],
            hasMoreDocument: newArr.length >= 5,
          },
        });
        onComplete();
      });
  };

export const deleteBlog =
  (id, imageUrl, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      await firebase.firestore().collection("tech_Forum").doc(id).delete();
      if (imageUrl) {
        await firebase.storage().refFromURL(imageUrl).delete();
      }
      dispatch({
        type: "DELETE_BLOG_DATA",
        payload: id,
      });
      toast.success("Blog Deleted Successfully");
    } catch (error) {
      console.error("Error deleting blog:", error);
      toast.error("Error deleting BLOG");
    } finally {
      onComplete();
    }
  };

export const updateBlog =
  (blogData, onComplete = () => {}) =>
  async (dispatch) => {
    let { image, oldImage, editingBlogId, description, imageUrl, ...newData } =
      blogData;
    const formattedDescription =
      typeof description === "object"
        ? JSON.stringify(description)
        : description;
    let finalImageUrl =
      imageUrl || (typeof oldImage === "string" ? oldImage : "");
    let updatedBlogData = {
      ...newData,
      description: formattedDescription,
      imageUrl: finalImageUrl,
    };
    try {
      if (image instanceof File) {
        if (typeof oldImage === "string" && oldImage.startsWith("https://")) {
          await firebase.storage().refFromURL(oldImage).delete();
        }
        const storageRef = storage.ref();
        const imageRef = storageRef.child(`athleteBlogImages/${image.name}`);
        imageRef
          .put(image)
          .then((snapshot) => snapshot.ref.getDownloadURL())
          .then((url) => {
            updatedBlogData.imageUrl = url;
            return firebase
              .firestore()
              .collection("tech_Forum")
              .doc(editingBlogId)
              .update(updatedBlogData);
          })
          .then(() => {
            dispatch({
              type: "EDIT_BLOG_DATA",
              payload: { editingBlogId, blogData: updatedBlogData },
            });
            onComplete();
            toast.success("Blog updated successfully!");
          })
          .catch((error) => {
            console.error("Error uploading image:", error);
            toast.error("Error uploading image");
          });
      } else {
        firebase
          .firestore()
          .collection("tech_Forum")
          .doc(editingBlogId)
          .update(updatedBlogData)
          .then(() => {
            dispatch({
              type: "EDIT_BLOG_DATA",
              payload: { editingBlogId, blogData: updatedBlogData },
            });
            onComplete();
            toast.success("Blog updated successfully!");
          });
      }
    } catch (error) {
      console.error("Error updating blog:", error);
      toast.error("Error updating blog");
    }
  };
